module.exports = __webpack_public_path__ + "static/media/twitter-polos.6fd4ff2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/twitter-polos.svg
// module id = 811
// module chunks = 0